// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================== */
/*          VARIABLES         */
/* ========================== */

:root {
  --color-header: #0b0500;
  --color-footer: #0b0500;
  --color-background: black;
  --color-text-dark: black;
  --color-text-light: #faf9f6;
  --line-GR: #38b000;
  --line-RD: #d90429;
  --line-OR: #fb6107;
  --line-YL: #ffd700;
  --line-SV: #b2b4b2;
  --line-BL: #3772ff;
  --dot-on: #ebb100;
  --dot-off: #111111;
  --dot-dim: #7a7157;
  --border-radius: 0.5rem;
}

/* ========================== */
/*      GENERAL STYLES        */
/* ========================== */

body {
  font-family:
    "Helvetica Neue",
    -apple-system,
    sans-serif;
  color: var(--color-text-light);
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  padding: 2rem;
  width: 100vw;
  flex: 1;
  box-sizing: border-box;
}

main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

button {
  background-color: white;
  color: var(--color-text-dark);
  border-radius: var(--border-radius);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border: none;
  text-transform: uppercase;
  cursor: pointer;
}
button:hover {
  background-color: #eee;
}

.btn-dark {
  background-color: #222;
  color: var(--color-text-light);
}
.btn-dark:hover {
  background-color: #333;
}
.btn-dark.line-GR:hover {
  background-color: var(--line-GR);
  color: var(--color-text-light);
}
.btn-dark.line-RD:hover {
  background-color: var(--line-RD);
  color: var(--color-text-light);
}
.btn-dark.line-BL:hover {
  background-color: var(--line-BL);
  color: var(--color-text-light);
}
.btn-dark.line-OR:hover {
  background-color: var(--line-OR);
  color: var(--color-text-dark);
}
.btn-dark.line-YL:hover {
  background-color: var(--line-YL);
  color: var(--color-text-dark);
}
.btn-dark.line-SV:hover {
  background-color: var(--line-SV);
  color: var(--color-text-dark);
}
.btn-dark.selected {
  pointer-events: none;
  background-color: var(--color-background);
}

[hidden] {
  display: none !important;
}

/* ========================== */
/*        HEADER & NAV        */
/* ========================== */

header {
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  color: var(--color-text-light);
}

header h1 {
  color: var(--color-text-light);
  margin: 0;
  font-size: 1.75rem;
  font-weight: 400;
  text-transform: uppercase;
}

/* ========================== */
/*         OTHER STYLES       */
/* ========================== */

@media screen and (max-width: 768px) {
  header h1 {
    font-size: 1.25rem;
  }

  .app-wrapper {
    padding: 1rem;
  }

  button {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B,+BAA+B;AAC/B,+BAA+B;;AAE/B;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B,+BAA+B;AAC/B,+BAA+B;;AAE/B;EACE;;;cAGY;EACZ,8BAA8B;EAC9B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B,+BAA+B;AAC/B,+BAA+B;;AAE/B;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B,+BAA+B;AAC/B,+BAA+B;;AAE/B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["/* ========================== */\n/*          VARIABLES         */\n/* ========================== */\n\n:root {\n  --color-header: #0b0500;\n  --color-footer: #0b0500;\n  --color-background: black;\n  --color-text-dark: black;\n  --color-text-light: #faf9f6;\n  --line-GR: #38b000;\n  --line-RD: #d90429;\n  --line-OR: #fb6107;\n  --line-YL: #ffd700;\n  --line-SV: #b2b4b2;\n  --line-BL: #3772ff;\n  --dot-on: #ebb100;\n  --dot-off: #111111;\n  --dot-dim: #7a7157;\n  --border-radius: 0.5rem;\n}\n\n/* ========================== */\n/*      GENERAL STYLES        */\n/* ========================== */\n\nbody {\n  font-family:\n    \"Helvetica Neue\",\n    -apple-system,\n    sans-serif;\n  color: var(--color-text-light);\n  background-color: var(--color-background);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  margin: 0;\n}\n\n.app-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  width: 100vw;\n  flex: 1;\n  box-sizing: border-box;\n}\n\nmain {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\nbutton {\n  background-color: white;\n  color: var(--color-text-dark);\n  border-radius: var(--border-radius);\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border: none;\n  text-transform: uppercase;\n  cursor: pointer;\n}\nbutton:hover {\n  background-color: #eee;\n}\n\n.btn-dark {\n  background-color: #222;\n  color: var(--color-text-light);\n}\n.btn-dark:hover {\n  background-color: #333;\n}\n.btn-dark.line-GR:hover {\n  background-color: var(--line-GR);\n  color: var(--color-text-light);\n}\n.btn-dark.line-RD:hover {\n  background-color: var(--line-RD);\n  color: var(--color-text-light);\n}\n.btn-dark.line-BL:hover {\n  background-color: var(--line-BL);\n  color: var(--color-text-light);\n}\n.btn-dark.line-OR:hover {\n  background-color: var(--line-OR);\n  color: var(--color-text-dark);\n}\n.btn-dark.line-YL:hover {\n  background-color: var(--line-YL);\n  color: var(--color-text-dark);\n}\n.btn-dark.line-SV:hover {\n  background-color: var(--line-SV);\n  color: var(--color-text-dark);\n}\n.btn-dark.selected {\n  pointer-events: none;\n  background-color: var(--color-background);\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/* ========================== */\n/*        HEADER & NAV        */\n/* ========================== */\n\nheader {\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  color: var(--color-text-light);\n}\n\nheader h1 {\n  color: var(--color-text-light);\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n\n/* ========================== */\n/*         OTHER STYLES       */\n/* ========================== */\n\n@media screen and (max-width: 768px) {\n  header h1 {\n    font-size: 1.25rem;\n  }\n\n  .app-wrapper {\n    padding: 1rem;\n  }\n\n  button {\n    font-size: 1rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
